import BttfAxios from "@features/utils/axios";
import { AxiosResponse } from "axios";

export const AGREEMENT_TYPES = {
  CRYPTO_TRADING: "crypto_trading",
  ETH_STAKING: "eth_staking",
  CRYPTO_DEPOSITS: "crypto_deposits",
  CRYPTO_WITHDRAWALS: "crypto_withdrawals",
} as const;

export type AgreementType =
  (typeof AGREEMENT_TYPES)[keyof typeof AGREEMENT_TYPES];

class UserAgreementsClass {
  public updateUserAgreements(
    agreement_type: AgreementType
  ): Promise<AxiosResponse> {
    return BttfAxios.post(
      `/api/user_agreements/accept`,
      { agreement_type },
      (resp) => resp
    );
  }
}
const UserAgreementsService = new UserAgreementsClass();

export default UserAgreementsService;
